export default __webpack_public_path__ + "static/media/callvideoLoginWhite.97a5db21.png";